<template>
    <div class="user-info flex">
        <base-user-avatar
            class="user-image-container"
            @click="handleUploadModal"
        />
        <base-user-details />
        <transition
            name="fade"
        >
             <image-modal
                v-if="imageModal"
                @close-modal="handleUploadModal"
            />
        </transition>
    </div>
</template>

<script>
import ImageModal from './ImageModal.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        ImageModal,
    },

    data: () => ({
        imageModal: false,
    }),

    computed: {
        ...mapState(['user']),
        ...mapGetters(['avatarUrl']),
    },

    methods: {
        /**
         * Opens image upload modal
         *
         */
        handleUploadModal() {
            this.imageModal = ! this.imageModal;
        },
    },
};
</script>
